import React from 'react';

const Footer = () => {
  return (
    <div id="fh5co-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>© {new Date().getFullYear()} Dang Phuong Khoi Nguyen. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;